import type { BoxProps } from "@highoutput/ui-components";
import { Badge, Box, Icon, Text, Tooltip } from "@highoutput/ui-components";
import type { MemberCoreDataFragment } from "~/__generated__/graphql";
import CertificateIcon from "../icons/certificate";

type CertificatesProps = {
  data: NonNullable<MemberCoreDataFragment["certificates"]>;
};

export default function Certificates(props: CertificatesProps & BoxProps) {
  const { data, ...others } = props;
  const totalCerts = data?.length ?? 0;

  if (totalCerts <= 0) return null;

  return (
    <Box {...others}>
      <Tooltip
        label={
          <Box>
            {data?.map((cert) => (
              <Text key={cert?.id}>{cert?.name}</Text>
            ))}
          </Box>
        }
        hasArrow
        color="rgba(240,237,236,0.2)"
        bgColor="neutrals.800"
        fontWeight="normal"
        paddingX={3}
        paddingY={2}
        rounded="lg"
        placement="top"
      >
        <Badge
          bgColor="#FCD77C"
          fontSize="12px"
          lineHeight="12px"
          paddingX="10px"
          paddingY="2px"
          display="flex"
          gap="8px"
          fontWeight="medium"
          alignItems="center"
          width="fit-content"
          color="#0F0F0F"
          rounded="16px"
          cursor="default"
        >
          <Icon as={CertificateIcon} width="16px" height="16px" stroke="#2E2E2E" />

          {totalCerts === 1 && <>{totalCerts} certificate</>}
          {totalCerts !== 1 && <>{totalCerts} certificates</>}
        </Badge>
      </Tooltip>
    </Box>
  );
}
